<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="btn">
			<div class="jiams tj">
				<div>请选择设备：</div>
				<Select v-model="query.macs" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<!-- <div class="comm tj">
				<div>请选择商品：</div>
				<Select v-model="query.comms" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in comms" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div> -->
			<div class="time tj">
				<div>请选择时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model="kaishi" style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model="jieshu" style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div>
			<Button type="info" @click="daochu">导出</Button>
		</div>
		<div class="tongji">
			<div style="color: red;font-size: 12px;">备注:1元=100积分</div>
		</div>
		<div class="tongji">
			<Tag size="large" color="orange">总金额:{{map.totalMoney}}元</Tag>
			<Tag size="large" color="green">微信:{{map.wechatMoney}}元</Tag>
			<Tag size="large" color="green">微信退款:{{map.wechatRefundMoney}}元</Tag>
			<Tag size="large" color="cyan">支付宝:{{map.alpayMoney}}元</Tag>
			<Tag size="large" color="cyan">支付宝退款:{{map.alpayRefundMoney}}元</Tag>
			<Tag size="large" color="blue">环保积分积分:{{map.xiaojieMoney}}元</Tag>
			<Tag size="large" color="blue">环保积分退款:{{map.xiaojieRefundMoney}}元</Tag>
			<!-- <Tag size="large" color="geekblue">小善积分:{{map.xiaoshanMoney}}元</Tag>
			<Tag size="large" color="geekblue">小善积分退款:{{map.xiaoshanRefundMoney}}元</Tag>
		 -->
		</div>
		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
			<!-- 	<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
		<Table width="0" height="0"  border ref="daochu" :columns="columns12" :data="data61">

			<template slot-scope="{ row, index }" slot="action">

			</template>
		</Table>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				kaishi:'',
				jieshu:'',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//商品列表
				comms: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						title: '订单id',
						width: 100,
						fixed: 'left',
						key: 'orderId'
					},

					// {
					// 	title: '订单标识',
					// 	width: 100,
					// 	fixed: 'left',
					// 	key: 'orderCode'
					// },
					{
						title: '交易时间',
						width: 150,
						key: 'createdTime',

					},
					{
						title: '用户id',
						width: 100,
						key: 'clientId'
					},
					{
						title: '设备id',
						width: 100,
						key: 'macLeaveFactoryId'
					},
					{
						title: '货道编号',
						width: 100,
						key: 'macLeaveFactoryAisleNumber'
					},
					{
						title: '商品名称',
						width: 200,
						key: 'commodityName'
					},

					{
						title: '应出数量',
						width: 100,
						key: 'number'
					},
					{
						title: '已出数量',
						width: 100,
						key: 'shipmentNumber'
					},


					{
						title: '售价',
						key: 'sellPrice',
						width: 100,
						render: (h, params) => {
							return h("div",params.row.sellPrice)
						}
					},
					{
						title: '进价',
						key: 'purchasingPrice',
						width: 100,
						render: (h, params) => {
							return h("div",params.row.purchasingPrice)
						}
					},
					{
						title: '总金额',
						key: 'money',
						width: 100,
						render: (h, params) => {
							return h("div",(params.row.sellPrice*params.row.number).toFixed(2))
						}
					},

					{
						title: '指令是否下发',
						key: 'isShipment',
						width: 100,
						render: (h, params) => {
							if(params.row.isShipment){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"指令已下发")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"指令未下发")
							}

						}
					},
					{
						title: '出货结果',
						key: 'result',
						width: 100,
						render: (h, params) => {
							if(params.row.result=='暂无'){
								return h("div",{
									style: {
									             color: '#ff9900'
									          }
								},"暂无")
							}else if(params.row.number==params.row.shipmentNumber){
								return h("div",{
									style: {
									             color: '#19be6b'
									          }
								},"正常")
							}else{
								return h("div",{
									style: {
									             color: '#ed4014'
									          }
								},"异常")
							}
						}
					},
					{
						title: '是否退款',
						key: 'isrefundString',
						width: 100,
						render: (h, params) => {
							switch (params.row.isrefund){
								case '1':
								    return h("div",{style: {color: '#ebe409'}},"正在退款")
									break;
								case '2':
								    return h("div",{style: {color: 'red'}},"已退款")
									break;
								default:
								    return h("div","未退款")
									break;
							}
						}
					},
					{
						title: '已退款金额',
						key: 'refundMoney',
						width: 100,
						render: (h, params) => {
							if(params.row.refundMoney>0){
								return h("div",params.row.refundMoney)
							}else{
								return h("div",0)
							}

						}
					},
					{
						title: '条形码',
						width: 200,
						key: 'barCode'
					},
					{
						title: '规格',
						width: 200,
						key: 'specification'
					},
					{
						title: '生产厂家',
						width: 200,
						key: 'operCommManu'
					},
					{
						title: '抽成方式',
						key: 'commissionWay',
						width: 100,
						render: (h, params) => {
							if(params.row.commissionWay==0){
								return h("div","总金额")
							}else if(params.row.commissionWay==1){
								return h("div","一级分类")
							}else  if(params.row.commissionWay==2){
								return h("div","二级分类")
							}else{
								return h("div","三级分类")
							}
						}
					},
					{
						title: '抽成比例',
						key: 'rake',
						width: 100,
						render: (h, params) => {
							return h("div",params.row.rake/100 +"%")
						}
					},
					{
						title: '抽成金额',
						key: 'commissionMoney',
						width: 100,
					},
					/* {
						title: '操作',
						slot: 'action',
						width: 80,
						align: 'center'
					} */
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					//开始时间
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
					macs:[],//设备信息id
					comms:[],//商品id,
					orderId:''
				},
				querys: {
					page: '0',
					size: '1000',
					//开始时间
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
					macs:[],//设备信息id
					comms:[],//商品id,
					orderId:''
				},
				map:{
					totalMoney:0,
					wechatMoney:0,
					wechatRefundMoney:0,
					alpayMoney:0,
					alpayRefundMoney:0,
					xiaojieMoney:0,
					xiaojieRefundMoney:0,
					xiaoshanMoney:0,
					xiaoshanRefundMoney:0,
				},

				isDc:true,
				data61:[],
				columns121:[],
				loading:false
			}
		},
		methods: {
			daochu(){
				let _this=this
				// _this.$refs.daochu.exportCsv({

				// });
				if(_this.isDc){
					_this.isDc=false
					 _this.$Message.info('正在准备数据，请不要关闭浏览器');
				}else{
					_this.$Message.info('正在准备数据，请不要关闭浏览器');
					return ;
				}
				let aa={
					page: 0,
					size: 2000,
					//开始时间
					kaishiTime:_this.query.kaishiTime,
					//结束时间
					jieshuTime:_this.query.jieshuTime,
					macs:_this.query.macs,//设备信息id
					comms:_this.query.comms,//商品id,
					orderId:_this.query.orderId
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/oper',
				    data:aa,
					_this: _this,
					success: function(data) {

						_this.data61 = data.page.content
						setTimeout(function(){
							_this.isDc=true
							_this.$refs.daochu.exportCsv({

							});
						},2000)

					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},
			ret() { //返回上一页
				this.$router.back()
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				_this.query.page=0
				_this.query.size=10
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					if(ks >=js){
						_this.$Message.error('开始时间必须小于结束时间!');
					}else{

						this.showPage = false
						this.$nextTick(() => {
							this.showPage = true
						})
						_this.ajaxPage()
						this.queryOperStatistics()
					}

				}else{

					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onclear(){
				let _this=this
				_this.query.page=0

				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
				this.queryOperStatistics()
			},
			onchangeSousuo(){

				let _this=this
				_this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			aisle(row) { //货道商品信息
				this.$router.push({
					name: 'oper/mac/aisle/list',
					query: {
						id: row.id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content

						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},
			queryOperStatistics(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/page/oper/statistics',
				    data: _this.query,
					_this: _this,
					success: function(data) {
							_this.map = data.map
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},
			queryMacs(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: _this.querys,
					_this: _this,
					success: function(data) {
						let items = data.macFaultDetailss.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].macCode
							_this.macs.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			queryComms(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComMerchandise/page',
				    data: {
						page: '0',
						size: '500',
					},
					_this: _this,
					success: function(data) {
						let items = data.page.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].name
							_this.comms.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}

		},
		components: {
			page
		},
		created() {
			let _this=this
			_this.kaishi=_this.$route.query.kaishi
			_this.jieshu=_this.$route.query.jieshu
			_this.query.kaishiTime=_this.$route.query.kaishi
			_this.query.jieshuTime=_this.$route.query.jieshu
			_this.query.macs.push(Number(_this.$route.query.macId))

			// this.ajaxPage()
			// this.queryOperStatistics()
			this.queryMacs()
			// this.queryComms()
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		},
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/finance/list.vue